// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { Author } from '../../../_contracts'
import { ArticleAuthor } from '../../ArticleAuthor'
import { ActionButton, IActionButton } from '../../ActionButton'

@Component<ArticleAuthorBlock>({
  name: 'ArticleAuthorBlock',
  components: {
    ActionButton,
    ArticleAuthor
  },

  template: `
    <ArticleAuthor
      :publicationDate="publicationDate"
      :hideDate="hideDate"
      :author="author"
      :showInitialsWhenNoAvatar="true"
      :showReadingTime="true"
      :isMobile="isMobile"
    >
      <ActionButton v-if="pdfAction" class="d-md-none" v-bind="pdfAction" />
    </ArticleAuthor>
  `
})
export class ArticleAuthorBlock extends Vue {
  @Prop({ type: Object, required: false, default: null })
  public readonly pdfAction!: IActionButton | null

  @Prop({ type: Object, required: true })
  public readonly author!: Author

  @Prop({ type: Boolean, required: false, default: false })
  protected readonly isLazy!: boolean

  @Prop({ type: Boolean, required: false, default: false })
  public readonly isMobile!: boolean

  @Prop({ type: Boolean, required: false, default: false })
  protected readonly hideDate!: boolean

  @Prop({ type: String, required: false, default: false })
  protected readonly publicationDate!: string
}
